import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isTouchDevice from 'is-touch-device';
import disableScroll from 'no-scroll';
import $ from 'jquery';

import ui from '@watsi/ui';
import Modal from './Modal';
import FormField from './FormField';
import FooterUpsell from './FooterUpsell';
import SubscribeButton from './SubscribeButton';

const { Button } = ui.components;

// These footer photos are stored in our watsi-blog s3 bucket at https://s3.console.aws.amazon.com/s3/buckets/watsi-blog/
const styles = `
  .FooterUpsell-image {
    background-image: url('https://d1e1ypz079s43d.cloudfront.net/upsell-mobile.jpg');
    background-size: auto 650px;
    background-position: right -70px bottom;
  }

  @media only screen and (min-width: 380px) {
    .FooterUpsell-image {
      background-position: right -40px bottom;
    }
  }

  @media only screen and (min-width: 425px) {
    .FooterUpsell-image {
      background-size: auto 800px;
      background-position: right -40px bottom;
    }
  }

  @media only screen and (min-width: 500px) {
    .FooterUpsell-image {
      background-image: url('https://d1e1ypz079s43d.cloudfront.net/upsell-tablet.jpg');
      background-size: auto 680px;
      background-position: right bottom -40px;
    }
  }

  @media only screen and (min-width: 800px) {
    .FooterUpsell-image {
      background-image: url('https://d1e1ypz079s43d.cloudfront.net/upsell-desktop.jpg');
      background-size: auto 550px;
      background-position: right bottom;
    }
  }

  @media only screen and (min-width: 1024px) {
    .FooterUpsell-image {
      background-size: auto 700px;
      background-position: right bottom -100px;
    }
  }

  @media only screen and (min-width: 1300px) {
    .FooterUpsell-image {
      background-size: auto 800px;
      background-position: right -100px bottom;
    }
  }

  @media only screen and (min-width: 1440px) {
    .FooterUpsell-image {
      background-image: url('https://d1e1ypz079s43d.cloudfront.net/upsell-desktop-large.jpg');
      background-size: auto 550px;
      background-position: right bottom;
    }
  }

  @media only screen and (min-width: 1600px) {
    .FooterUpsell-image {
      background-size: auto 700px;
      background-position: right bottom;
    }
  }
`;

const isEmail = str => /^.+@.+\..+$/.test(str);

export default class BlogSubscribeFooterUpsell extends Component {
  state = {
    isModalOpen: false,
    isSubmitting: false,
    isSubmitted: false,
    hasError: false,
    email: '',
    errorMessage: '',
  }

  handleSubscribeClick = (e) => {
    e.preventDefault();
    disableScroll.on();
    this.setState({ isModalOpen: true });
  }

  handleModalRequestClose = (e) => {
    if (e) {
      e.preventDefault();
    }
    disableScroll.off();
    this.setState({ isModalOpen: false });
  }

  handleEmailInputChange = (e) => {
    this.setState({ email: e.target.value, hasError: false });
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const email = this.state.email.trim();

    if (!isEmail(email)) {
      this.setState({ errorMessage: 'Please provide a valid email address.', hasError: true });
      return;
    }

    this.setState({ isSubmitting: true });

    // $.post('http://localhost:4000/internal_api/blog/subscribe', { email })
    $.post('https://watsi.org/internal_api/blog/subscribe', { email })
      .done(() => {
        this.setState({ isSubmitting: false, isSubmitted: true });
        setTimeout(() => {
          this.setState({ isModalOpen: false, isSubmitted: false, email: '' });
        }, 2500);
        if (typeof analytics !== 'undefined') {
          analytics.track('Email Subscribe', { email });
        }
      })
      .fail(() => {
        this.setState({
          isSubmitting: false,
          hasError: true,
          errorMessage: 'We couldn’t subscribe you at this time. Please try again later.'
        });
      })
      .always(() => {
        this.setState({ isSubmitting: false });
      });
  }

  render () {
    const { errorMessage, email, hasError, isModalOpen, isSubmitting, isSubmitted } = this.state;
    const isEmpty = email.trim().length === 0;

    return (
      <FooterUpsell caption="Jacob, accessing care at the Rwibaale clinic for the first time.">
        <h2 className="text-5 text-7-l fontWeight-semibold">
          Subscribe for updates about&nbsp;Watsi
        </h2>
        <h3 className="text-3 text-4-l marginTop-16 marginBottom-32 marginLeft-16 marginLeft-0-m marginRight-16 marginRight-0-m">Stay updated on our progress towards universal healthcare.</h3>
        <Button filled large onClick={this.handleSubscribeClick}>
          Subscribe
        </Button>
        <Modal
          title="Subscribe for updates about Watsi"
          isOpen={isModalOpen}
          onRequestClose={this.handleModalRequestClose}>
          <h2 className="text-4">Follow our journey to bring healthcare to everyone in the world.</h2>
          <form method="post" className="position-relative marginTop-32" noValidate onSubmit={this.handleSubmit}>
            <FormField
              name="email"
              type="email"
              label="Email Address"
              onChange={this.handleEmailInputChange}
              hasError={hasError}
              value={email}
              autoFocus={!isTouchDevice()} />
            <div className="marginTop-16">
              {hasError && (
                <div className="Tooltip" style={{ bottom: '100%', left: 0 }}>
                  <div className="Tooltip-content">{errorMessage}</div>
                </div>
              )}
              <SubscribeButton
                type="submit"
                disabled={isEmpty}
                isSubmitting={isSubmitting}
                isSubmitted={isSubmitted} />
            </div>
          </form>
        </Modal>
        <style dangerouslySetInnerHTML={{ __html: styles }} />
      </FooterUpsell>
    );
  }
}
